import { Spin } from 'antd'
import type { FC, ReactNode } from 'react'
import { Navigate, useParams } from 'react-router'

import { PathUtils } from 'routes/routes.utils'

import { SERIES_PAGES_TEXT } from '../pages/shared/seriesPagesText'
import { useSeriesPagesGate } from '../useSeriesPagesGate'
import styles from './seriesGate.module.scss'

type SeriesGateProps = {
  children: ReactNode
}

export const SeriesGate: FC<SeriesGateProps> = ({ children }) => {
  const { siteId = '' } = useParams()
  const gate = useSeriesPagesGate()

  if (gate === 'pending') {
    return (
      <div className={styles.pending} role='status' aria-label={SERIES_PAGES_TEXT.gate.loading}>
        <Spin />
      </div>
    )
  }
  if (gate === 'blocked') return <Navigate to={PathUtils.getSchedule(siteId)} replace />
  return <>{children}</>
}
